var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"accent","dark":"","app":""}},[_c('div',[_c('h3',[_vm._v("Ver. 1.0.7")])]),_c('v-spacer'),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+" B.P.WORKS inc.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }